function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import SwiperSlider from 'integration-web-core--socle/js/assets/modules/_swiperSlider.class.js';
import Accordion from '@mozaic-ds/freemarker/js/modules/_accordion.js';
import Modal from '@mozaic-ds/freemarker/js/modules/_modal.js';
var OnlineCourse = /*#__PURE__*/function (_lm$Composant) {
  /**
   * @constructor
   * @param {String} id
   */
  function OnlineCourse(id) {
    var _this;
    _classCallCheck(this, OnlineCourse);
    _this = _callSuper(this, OnlineCourse, [id]);

    // Swiper
    _toConsumableArray(_this.target.querySelectorAll('.m-carousel')).forEach(function (carousel) {
      new SwiperSlider(carousel, null, {
        centerWhenNoButtons: false
      });
    });

    // Create modal for Before Start
    var modal = new Modal({
      'classContent': 'o-modal__first'
    });
    _toConsumableArray(_this.target.querySelectorAll('.o-modal__button-opener')).forEach(function (buttonOpener) {
      buttonOpener.addEventListener('click', function () {
        var classModal = buttonOpener.dataset["class"];
        var modalToOpen = document.querySelector('.' + classModal);
        var secondModalImpl = new Modal({
          'classContent': classModal
        });
        secondModalImpl.open();
        modalToOpen.focus();

        // For each modal, implement "prev" button with the id prev
        modalToOpen.querySelector('.js-modal-prev').addEventListener('click', function () {
          secondModalImpl.close();
          modal.open();
        });
      });
    });

    // Layer
    var jsOpenLayer = document.getElementById('js-open-layer');
    if (jsOpenLayer) {
      jsOpenLayer.addEventListener('click', function () {
        modal.open();
      });
    }

    // Jsonld
    window.addEventListener('DOMContentLoaded', function () {
      var jsonldData = JSON.parse(document.querySelector('#component-onlinecourse').querySelector('script.dataJsonLd').innerHTML);
      if (jsonldData) {
        window.MetaTagEventBus.emit('jsonLdTrigger', {
          data: jsonldData
        });
      }
    });

    // Init accordions
    _toConsumableArray(_this.target.querySelectorAll('.js-accordion')).forEach(function (el) {
      new Accordion(el);
    });
    return _this;
  }
  _inherits(OnlineCourse, _lm$Composant);
  return _createClass(OnlineCourse);
}(lm.Composant); // Add tag for Sentry
lm.sentry.configureScope(function (scope) {
  scope.setTag('kobi.composant', 'onlinecourse');
});
lm.DOMReady(function () {
  new OnlineCourse('onlinecourse');
});